<template>
    <div
        class="grid-item grid-item-half grid-item-break-half">
        <p class="stack-s">Resource</p>
        <v-radio
            v-for="(resourceOption, index) in resources"
            group="resource"
            :class="{'stack-m': resources.length - 1 !== index}"
            :key="resourceOption.value"
            :label="resourceOption.label"
            :value="resourceOption.value"
            :model="resource"
            :validate="validate"
            @update="updateResource"
        />
    </div>
</template>
<script>
    import _ from '@/common/helpers';
    import {DataExportModel} from '@/common/models/data-export-model';
    import {vRadio} from '@/components/form';

    export default {
        name: 'resource-form',
        components: {
            vRadio,
        },
        props: {
            validate: {
                type: Object,
                required: true,
            },
            resource: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                resources: Object.values(DataExportModel.Resources)
                    .map(resourceName => ({
                        value: resourceName,
                        label: _.capitalize(resourceName),
                    })),
            };
        },
        methods: {
            updateResource(resource) {
                this.$emit('update', resource);
            },
        },
    };
</script>
